// hooks/useCandidateGroups.js
import { useCallback, useEffect, useState } from "react";
import { fetchCandidateGroups } from "../api/transportBoardApi";

export function useCandidateGroups(campDateStr) {
  const [candidateRows, setCandidateRows] = useState([]);
  const [candidatesLoading, setCandidatesLoading] = useState(false);
  const [candidatesError, setCandidatesError] = useState(null);

  const reloadCandidateGroups = useCallback(async () => {
    if (!campDateStr) {
      setCandidateRows([]);
      setCandidatesError(null);
      return;
    }

    setCandidatesLoading(true);
    setCandidatesError(null);

    try {
      const rows = await fetchCandidateGroups(campDateStr);
      setCandidateRows(rows);
    } catch (e) {
      setCandidatesError(e);
      setCandidateRows([]);
    } finally {
      setCandidatesLoading(false);
    }
  }, [campDateStr]);

  useEffect(() => {
    reloadCandidateGroups();
  }, [reloadCandidateGroups]);

  return {
    candidateRows,
    candidatesLoading,
    candidatesError,
    reloadCandidateGroups,
  };
}